import { render, staticRenderFns } from "./HumanCapitalAccidentsCountReport.vue?vue&type=template&id=0ad1e71a&scoped=true&"
import script from "./HumanCapitalAccidentsCountReport.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalAccidentsCountReport.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalAccidentsCountReport.vue?vue&type=style&index=0&id=0ad1e71a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad1e71a",
  null
  
)

export default component.exports